import { logger } from 'monitor';

import { getCookie } from '../../getCookie';

export interface UserFromAnalytics {
  email: string;
}

export const useCurrentUserFromAnalyticsCookie = (): UserFromAnalytics | undefined => {
  const email = getCookie('safi_analytics__email');

  if (email) {
    try {
      return {
        email,
      };
    } catch (e) {
      logger.error('Error parsing analytics cookie');
    }
  }
};
